import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { ModelActionsModal } from '@models-global/model-actions';
import * as actions from '@module-claims/store/prescriber.actions';
import { PrescriberCEAssociationAddParams } from '@module-claims/models/prescriber.interface';

export interface ICEAssociationModalState {
  readonly action?: ModelActionsModal;
  readonly data?: PrescriberCEAssociationAddParams;
}

@State<ICEAssociationModalState>({
  name: 'CEAssociationModalState',
  defaults: {
    action: undefined,
    data: undefined
  }
})
@Injectable()
export class CEAssociationModalState {
  @Action(actions.PrescriberCEAssociationModalSave)
  saveModal(
    ctx: StateContext<ICEAssociationModalState>,
    { params }: actions.PrescriberCEAssociationModalSave
  ): void {
    ctx.patchState({
      action: 'save',
      data: params
    });
  }

  @Action(actions.PrescriberCEAssociationModalClose)
  closeModal(ctx: StateContext<ICEAssociationModalState>): void {
    ctx.patchState({
      action: 'close',
      data: undefined
    });
  }
}
